import React, { Component } from 'react';
import Base from '../../../rebase';
import Firebase from 'firebase';
import PropTypes from 'prop-types';
import RSVPPerson from './RSVPPerson';
import RSVPPersonSummary from './RSVPPersonSummary';
import {
  PageHeader,
  Well,
  Modal,
  Button
} from 'react-bootstrap';

class RSVPSummaryModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      guests: [],
      show: false
    };
    this.handleHide = this.handleHide.bind(this);
    this.showStatus = this.showStatus.bind(this);
  }

  handleHide() {

    this.setState({ show: false });
  }

  showStatus() {
    Firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.ref = Base.fetch('users/' + user.uid + '/guests', {
          context: this,
          asArray: true
        })
        .then(data => {
          this.setState({guests: data});
          this.setState({ show: true })
        })
      } else {
        // No user is signed in.
        console.log("RSVPSection.jsx: not logged in");
      }
    });
  }

  render() {
    return (
      <div>
        <Button
          bsStyle="primary"
          bsSize="large"
          onClick={this.showStatus}
          style={{ display: "block", margin:"auto" }}
        >
          RSVP Status Check
        </Button>
        <div className="modal-container">
          <Modal
            show={this.state.show}
            onHide={this.handleHide}
            container={this}
            aria-labelledby="contained-modal-title"
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title">
                RSVP Submitted Summary
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {
                this.state.guests.map((item, index) => (
                  <RSVPPersonSummary guestID={item} />
                ))
              }
            </Modal.Body>
            <Modal.Footer>
              <p Style={"text-align:left"}>Please note that changes are possible up till the 15th of July.</p> 
              <Button onClick={this.handleHide}>Close</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
      )
  }
}

export default RSVPSummaryModal;



// WEBPACK FOOTER //
// ./src/reusable_components/page_components/RSVP/RSVPSummaryModal.jsx